"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorRdfMetadataExtractTraverse = void 0;
const bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");
const core_1 = require("@comunica/core");
/**
 * A comunica Traverse RDF Metadata Extract Actor.
 */
class ActorRdfMetadataExtractTraverse extends bus_rdf_metadata_extract_1.ActorRdfMetadataExtract {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const result = await this.mediatorExtractLinks.mediate(action);
        return {
            metadata: {
                traverse: result.links,
                traverseConditional: result.linksConditional,
            },
        };
    }
}
exports.ActorRdfMetadataExtractTraverse = ActorRdfMetadataExtractTraverse;
//# sourceMappingURL=ActorRdfMetadataExtractTraverse.js.map